module.exports = __webpack_public_path__ + "img/apidays-live-hongkong-2021-participants.62186490.png";